import "core-js/modules/es7.array.includes.js";
import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from "./routes";
import { store } from '@/store'; // import logger from '@/boot/logger';

import { queryParamFetch, checkForSlug, checkThroughParams } from "../functions/utils";
Vue.use(VueRouter);
/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation
 */

export default function () {
  var Router = new VueRouter({
    scrollBehavior: function scrollBehavior() {
      return {
        x: 0,
        y: 0
      };
    },
    routes: routes,
    // Leave these as they are and change in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    mode: process.env.VUE_ROUTER_MODE,
    base: process.env.VUE_ROUTER_BASE
  });
  Router.beforeEach(function (to, from, next) {
    ////////////////////////////////////////////////////////////////////////////////////////////////
    //    _  __          _           __  _             _____                 __
    //   / |/ /__ __  __(_)__ ____ _/ /_(_)__  ___    / ___/_ _____ ________/ /__
    //  /    / _ `/ |/ / / _ `/ _ `/ __/ / _ \/ _ \  / (_ / // / _ `/ __/ _  (_-<
    // /_/|_/\_,_/|___/_/\_, /\_,_/\__/_/\___/_//_/  \___/\_,_/\_,_/_/  \_,_/___/
    //                  /___/
    // NOTE: when adding a new route make sure that the route is included in the App.vue safe routes list, without this then the site will be redirected to the homepage without indication as to why
    var guardedRoutes = ['/', '/questions', '/register', '/staff', '/check_in/get_started', '/check_in/team_member_table_number_entry', '/check_in/team_member_receipt_pin_entry']; // Process navigation guards only if user is navigating to a guarded route

    if (guardedRoutes.includes(to.path)) {
      // Redirection helper - redirects and replaces the current URL with the target route
      var redirect = function redirect(route) {
        return next({
          path: route,
          replace: true
        });
      }; // Get data from the store


      var setupComplete = store.state.settings.setupComplete;
      var surveyInProgress = store.state.surveys.surveyInProgress;
      var isApp = store.get('config/isApp');
      var supportedDevice = store.get('app/supportedDevice');

      var checkIfSetupComplete = function checkIfSetupComplete() {
        if (isApp) {
          if (setupComplete) {
            next();
          } else {
            Logger.debug('Redirect to Device Registration page');
            redirect('/register');
          }
        } else {
          checkForSlug(store.state.checkIn.urlParams, to, redirect);
        }
      };

      if (isApp && setupComplete && !process.env.PWA_TESTING && !supportedDevice) {
        return;
      } // Redirect user to the appropriate page based on data from the store


      switch (to.path) {
        // Index page
        case '/':
          if (isApp) {
            // App
            if (!setupComplete) {
              Logger.debug('Redirect to Device Registration page');
              redirect('/register');
            } else {
              Logger.debug('Redirect to Staff page');
              redirect('/staff');
            }
          } else {
            // Get any url params that are present.
            var urlParams = queryParamFetch(to, 'web');
            checkThroughParams(urlParams, redirect);
          }

          break;
        // Questions page

        case '/questions':
          if (!surveyInProgress) {
            if (isApp) {
              // App
              Logger.debug('Redirect to Staff page');
              redirect('/staff');
            } else {
              // Web
              // No need to land on the checkin page as it doesn't do anything
              checkForSlug(store.state.checkIn.urlParams, to, redirect);
            }
          } else {
            next();
          }

          break;
        // Device Registration page

        case '/register':
          if (isApp) {
            // App
            if (setupComplete) {
              Logger.debug('Redirect to Staff page');
              redirect('/staff');
            } else {
              next();
            }
          } else {
            // Web
            // No need to land on the checkin page as it doesn't do anything
            checkForSlug(store.state.checkIn.urlParams, to, redirect);
          }

          break;
        // Staff page

        case '/staff':
          if (isApp) {
            checkIfSetupComplete();
          }

          break;
        // Get Started page

        case '/check_in/get_started':
          if (isApp) {
            checkIfSetupComplete();
          } else {
            next();
          }

          break;
        // Table Number page

        case '/check_in/team_member_table_number_entry':
          if (isApp) {
            checkIfSetupComplete();
          } else {
            next();
          }

          break;
        // Receipt PIN page

        case '/check_in/team_member_receipt_pin_entry':
          if (isApp) {
            checkIfSetupComplete();
          } else {
            next();
          }

          break;
      }

      return;
    } // Default navigation


    next();
  });
  Router.afterEach(function () {
    // set loading to false after every page load
    store.commit('app/SET_PAGE_LOADING', false);
    store.commit('app/SET_PAGE_LOADING_TYPE', '');
  });
  return Router;
}